import { Navigate } from 'react-router-dom';

// ── Guard de rol/módulo para rutas anidadas bajo /app/home y /app/free ──
export const ProtectedRoute = ({ rol, allowedRoles, allowed = true, redirectTo = "/app/home", children }) => {
  if (allowedRoles && !allowedRoles.includes(rol)) {
    // Un "cliente" (plan FREE) nunca pertenece a /app/home/* — lo mandamos a su propio árbol, no al de tenant.
    return <Navigate to={rol === "cliente" ? "/app/free/inicio" : redirectTo} replace />;
  }
  if (!allowed) return <Navigate to={redirectTo} replace />;
  return children;
};
